module.exports = __webpack_public_path__ + "img/line.d075261f.svg";